<nav class="main-header navbar navbar-expand navbar-white navbar-light sticky">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" data-widget="pushmenu" role="button"><i class="fa fa-bars"></i></a>
    </li>
  </ul>
  <div class="info">
    <img *ngIf = "!isCommercialization" src="assets/images/pet-logo-topbar.png" alt="Petronas" class="" style="height: 30px;" >
    <img *ngIf = "isCommercialization" src="assets/images/potf-logo-topbar.png" alt="Petronas" class="" style="height: 30px;" >
    &nbsp;
    <span [class.text-comm]="isCommercialization" [class.text-petronas]="!isCommercialization" style="font-size:16px">{{title}}</span>
  </div>
  <ul class="navbar-nav ml-auto">
    <li *ngIf="showNotification" class="nav-item user-menu nav-child-indent">
      <a class="nav-link dropdown-toggle m-0 pr-1" href="javascript:void(0);" id="navbarNotification" role="button" data-bs-toggle="dropdown" aria-expanded="false">
       <i class="fa fa-bell" aria-hidden="true" style="font-size:18px"></i>
        <span class="position-absolute top-30 start-100 translate-middle badge bg-danger" style="font-size:13px;">{{Notification?.totalNotification ?? 0}}</span>
      </a>
      <div  class="dropdown-menu dropdown-menu-lg dropdown-menu-end rounded border-0 mr-5" aria-labelledby="navbarNotification">
        <div *ngFor="let notification of Notification?.notificationByType" (click)="redirectToNotification(notification.routeTo)" class="dropdown-item">
          <span class="float-left mr-2 text-muted text-sm">{{notification?.count}} </span>
         <i aria-hidden="true"></i> {{notification?.requestType}}
        </div>
        <div class="dropdown-divider"></div> 
        <a class="dropdown-item disabled">
          <i aria-hidden="true"></i> Total Notification(s)
          <span class="float-right text-muted text-sm">{{Notification?.totalNotification}}</span>
        </a>
      </div>
    </li>
    <li class="nav-item user-menu nav-child-indent">
      <a class="nav-link dropdown-toggle" style="padding-top: 0rem; " href="javascript:void(0);" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
        <div class="user-panel pb-3 mb-3 d-flex" style="padding-top: 0rem; font-size:15px;">
          <div class="image">
            <i class="fa fa-user-circle fa-2x" aria-hidden="true"></i>
          </div>
          <div class="info">
            <span class="d-block">{{userName}}</span>
          </div>
        </div>
      </a>
      <ul class="dropdown-menu dropdown-menu-xl dropdown-menu-end rounded border-0" aria-labelledby="navbarDropdown">
        <li class="user-header rounded-top">
          <i class="fa fa-user-circle fa-5x" aria-hidden="true"></i>
          <p>
            <span class="loggedin-name" style="font-size:15px;">{{userName}}</span>
            <span class="d-block text-sm">{{userEmail}}</span>
          </p>
        </li>
        <li class="user-footer rounded-bottom">
          <div class="row" style="font-size:15px;">
            <div *ngIf="!isCommercialization" class="col-sm-12">
              <button *ngIf="showNotification" [routerLink]="'/notification'" class="btn bg-petronas btn-flat rounded btn-block"><i class="right fa fa-inbox"></i> Inbox</button>
            </div>
            <br/>
            <br/>
            <div *ngIf="!isCommercialization" class="col-sm-12">
              <button (click)="signOut()" class="btn bg-petronas btn-flat rounded btn-block">Sign out</button>
            </div>
            <div *ngIf="isCommercialization" class="col-sm-12">
              <button *ngIf="showNotification" [routerLink]="'/notification'" class="btn bg-comm btn-flat rounded btn-block"><i class="right fa fa-inbox"></i> Inbox</button>
            </div>
            <br/>
            <br/>
            <div *ngIf="isCommercialization" class="col-sm-12">
              <button (click)="signOut()" class="btn bg-comm btn-flat rounded btn-block">Sign out</button>
            </div>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</nav>
